import React from "react";
import AuditQueue from "./AuditQueue";

const ReleaseAuditDashboard = () => (
  <AuditQueue
    type="releases"
    stage={2}
    title="Release Audit Dashboard"
    subtitle="Releases approved by the Auditor General, waiting for the release auditor."
  />
);

export default ReleaseAuditDashboard;
